import { render, staticRenderFns } from "./FormImageItem.vue?vue&type=template&id=4d90a67e"
import script from "./FormImageItem.vue?vue&type=script&lang=js"
export * from "./FormImageItem.vue?vue&type=script&lang=js"
import style0 from "./FormImageItem.vue?vue&type=style&index=0&id=4d90a67e&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-store\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d90a67e')) {
      api.createRecord('4d90a67e', component.options)
    } else {
      api.reload('4d90a67e', component.options)
    }
    module.hot.accept("./FormImageItem.vue?vue&type=template&id=4d90a67e", function () {
      api.rerender('4d90a67e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/commonPage/components/tableComp/formItems/FormImageItem.vue"
export default component.exports